import * as yup from "yup";

export const jobTypesValidator = yup.object().shape({
  name: yup.string().required(),
  default_hourly_rate: yup.number().required(),
});
